import React, { useRef, useState } from 'react';
import './FileUpload.css';

const FileUpload = ({ onFilesSelected, onTextInput, disabled = false }) => {
  const [dragActive, setDragActive] = useState(false);
  const [inputText, setInputText] = useState('');
  const fileInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const files = Array.from(e.dataTransfer.files);
      onFilesSelected(files);
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const files = Array.from(e.target.files);
      onFilesSelected(files);
    }
  };

  const handleTextSubmit = () => {
    if (inputText.trim()) {
      onTextInput(inputText.trim());
      setInputText('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      handleTextSubmit();
    }
  };

  return (
    <div className="file-upload-container">
      <div className="upload-section">
        <div
          className={`upload-zone ${dragActive ? 'drag-active' : ''} ${disabled ? 'disabled' : ''}`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          onClick={() => !disabled && fileInputRef.current?.click()}
        >
          <div className="upload-content">
            <h3>Faça upload de arquivos</h3>
            <p>Arraste e solte arquivos aqui ou clique para selecionar</p>
            <span className="file-types">Suporta: PDF, DOC, DOCX, TXT, JPG, PNG</span>
          </div>
        </div>
        
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
          onChange={handleFileInput}
          disabled={disabled}
          style={{ display: 'none' }}
        />
      </div>

      <div className="divider">
        <span>ou</span>
      </div>

      <div className="text-input-section">
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Cole aqui o texto do pedido ou descrição dos itens..."
          rows={3}
          className="text-input"
          disabled={disabled}
        />
        <div className="text-input-actions">
          <button 
            className="btn btn-primary"
            onClick={handleTextSubmit}
            disabled={disabled || !inputText.trim()}
          >
            Adicionar Texto
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
